import React from "react";
import { Link } from "react-router-dom";

import Image from "assets/images/auth/password-reset.svg";
import { pathGenerators } from "utils/routes";

import { AuthLayout } from "../components/AuthLayout/AuthLayout";
import s from "./SuccessMsgPage.module.css";

const SuccessMsgPage = () => {
  return (
    <AuthLayout>
      <div className={s.container}>
        <h1 className={s.title}>Password reset link sent</h1>
        <p className={s.secondaryText}>
          Please check your email for instructions to reset your password
        </p>

        <img src={Image} alt="Envelope" />

        <Link to={pathGenerators.auth.login()} className={s.button}>
          Back to login
        </Link>
      </div>
    </AuthLayout>
  );
};

export { SuccessMsgPage };